import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import "./styles.css";

export default function App() {
  return (
    <Router>
      <div className="app">
        <nav className="nav">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/gallery" className="nav-link">Gallery</Link>
        </nav>
        
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
        </Routes>
      </div>
    </Router>
  );
}

function Home() {
  return (
    <div className="home">
      <h1>Welcome to Our Website</h1>
      <p>Explore our beautiful gallery of images.</p>
    </div>
  );
}

function Gallery() {
  const images = [
    "/images/image1.jpg",
    "/images/image2.jpg",
    "/images/image3.jpg",
    "/images/image4.jpg",
  ];

  return (
    <div className="gallery">
      <h2>Image Gallery</h2>
      <div className="image-grid">
        {images.map((src, index) => (
          console.log(src),
          
          <img key={index} src={src} alt="Random" className="image" />
        ))}
      </div>
    </div>
  );
}
